<template>
    <Button
        v-if="task"
        :color="color"
        @confirm="assignAgent"
        :disabled="loadingAssign"
        is="confirm"
        :text="text"
        :title="title"
        small
        >{{ label }}</Button
    >
</template>

<script>
    import { Alerts, Button } from '@tech_hexeko/design-system'
    import { formatError } from '@/plugins/errors.js'
    import Tasks from '@/mixins/Tasks'

    export default {
        name: 'ButtonAssignSelf',
        mixins: [Tasks],
        components: { Button },
        props: {
            task: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                loadingAssign: false,
            }
        },
        computed: {
            agentName() {
                return this.task?.agent?.name || 'someone'
            },
            color() {
                return this.isTaskAssigned ? 'warning' : 'success'
            },
            isTaskAssigned() {
                return this.task?.agent
            },
            label() {
                return this.isTaskAssigned ? 'Reassign to me' : 'Assign to me'
            },
            text() {
                return this.isTaskAssigned
                    ? `This task is already assigned to ${this.agentName}. Would you like to reassign it to yourself?`
                    : 'Once assigned, you will be responsible for managing this task. Confirm your assignment?'
            },
            title() {
                return this.isTaskAssigned ? 'Reassigning yourself?' : 'Assigning yourself?'
            },
        },
        methods: {
            async assignAgent() {
                if (!this.$store.getters?.getUser?.id || !this.task) return

                try {
                    this.loadingAssign = true
                    await this.$api.agents.assign(this.$store.getters.getUser.id, {
                        payable_id: this.task?.id,
                        payable_type: this.taskType,
                    })
                    Alerts.notificationSuccess('You have been assigned to this task')
                    this.$emit('success')
                } catch (err) {
                    const errorTxt = formatError(err)
                    Alerts.notificationError(errorTxt)
                } finally {
                    this.loadingAssign = false
                }
            },
        },
    }
</script>
